import { provide } from 'vue';
import { confetti } from '@tsparticles/confetti';
export const CONFETTI_CONTROLLER_KEY = Symbol('confettiController');

export interface ConfettiController {
    launch: () => void;
}

export function useConfettiProvider() {
    const controller = {
        launch: () => {
            confetti({
                particleCount: 200,
                spread: 360,
                ticks: 100,
                gravity: 0.5,
                decay: 0.95,
                startVelocity: 30,
                scalar: 1,
            });
        },
    };
    provide(CONFETTI_CONTROLLER_KEY, controller);

    return controller;
}
